import { AddOrUpdateAddressResponse } from '@woolworthsnz/trader-api';

/*
 * https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
 */

export const isAddOrUpdateAddressResponse = (response: any): response is AddOrUpdateAddressResponse =>
	(<AddOrUpdateAddressResponse>response).shopperAddresses !== undefined;
